function setupStudio(root=document){root.querySelectorAll('[data-gallery]').forEach(gallery=>{if(gallery.dataset.ready)return;gallery.dataset.ready='true';const slides=[...gallery.querySelectorAll('[data-slide]')],thumbs=[...gallery.querySelectorAll('[data-photo]')];let active=0;function show(index){active=(index+slides.length)%slides.length;slides.forEach((slide,i)=>{slide.hidden=i!==active;slide.classList.toggle('is-active',i===active)});thumbs.forEach((thumb,i)=>{thumb.classList.toggle('is-active',i===active);thumb.setAttribute('aria-pressed',String(i===active))})}thumbs.forEach(thumb=>thumb.addEventListener('click',()=>show(Number(thumb.dataset.photo))));gallery.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>show(active-1));gallery.querySelector('[data-gallery-next]')?.addEventListener('click',()=>show(active+1))});root.querySelectorAll('.sb-quantity-cart').forEach(form=>{if(form.dataset.ready)return;form.dataset.ready='true';const gift=form.querySelector('.sb-bundle-gift-value');form.querySelectorAll('input[name=quantity]').forEach(option=>option.addEventListener('change',()=>{if(option.checked&&gift)gift.value=option.dataset.gift||''}));const selector=form.querySelector('[data-variant-select]');selector?.addEventListener('change',()=>{const option=selector.selectedOptions[0],container=form.closest('[data-product]');container.querySelector('[data-product-price]').textContent=option.dataset.price;const button=form.querySelector('[data-add-button]');button.disabled=option.dataset.available!=='true'})})}setupStudio();document.addEventListener('shopify:section:load',event=>setupStudio(event.target));document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.mobile-menu[open]').forEach(menu=>menu.open=false)});

function setupAccessoryMenus(root=document){
  root.querySelectorAll('[data-accessory-menu]').forEach(menu=>{
    if(menu.dataset.ready)return;
    menu.dataset.ready='true';
    const button=menu.querySelector('[data-accessory-toggle]');
    const panel=menu.querySelector('[data-accessory-panel]');
    function setOpen(open){panel.hidden=!open;button.setAttribute('aria-expanded',String(open));}
    menu.addEventListener('mouseenter',()=>{if(matchMedia('(hover:hover)').matches)setOpen(true);});
    menu.addEventListener('mouseleave',()=>{if(!menu.contains(document.activeElement))setOpen(false);});
    button.addEventListener('click',()=>setOpen(true));
    button.addEventListener('keydown',event=>{if(event.key==='ArrowDown'){event.preventDefault();setOpen(true);panel.querySelector('a')?.focus();}});
    menu.addEventListener('focusout',event=>{if(!menu.contains(event.relatedTarget))setOpen(false);});
    menu.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();setOpen(false);button.focus();}});
    document.addEventListener('click',event=>{if(!menu.contains(event.target))setOpen(false);});
  });
}
setupAccessoryMenus();
document.addEventListener('shopify:section:load',event=>setupAccessoryMenus(event.target));

// Gift apps can change item keys and insert rows after the cart is rendered.
// Resolve the selected item's current key before removing it.
let studioCartRemovalPending = false;
function studioCartProperties(properties) {
  const entries = Array.isArray(properties) ? [...properties] : Object.entries(properties || {});
  return JSON.stringify(entries.sort(([a], [b]) => a.localeCompare(b)));
}

// Older V6 Plus and V6 Max carts can still carry notices from earlier product forms.
// Replace that line's properties before allowing it into checkout. Shopify does not clear
// existing line properties when change.js receives an empty properties object.
let studioCartCleanupPending = false;
async function studioCleanLegacyBackorderCart() {
  if (document.body.dataset.legacyBackorderCleanup !== 'true') return;
  studioCartCleanupPending = true;
  const cartUrl = document.body.dataset.cartUrl;
  const changeUrl = document.body.dataset.cartChangeUrl;
  const status = document.querySelector('[data-backorder-cleanup-status]');
  try {
    for (let attempt = 0; attempt < 50; attempt++) {
      const cartResponse = await fetch(cartUrl + '.js', { cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('Cart could not be loaded');
      const cart = await cartResponse.json();
      const item = cart.items.find(item =>
        (item.handle === 'vseebox-v6-plus-new' || item.handle === 'vseebox-v6-max-new') &&
        Object.prototype.hasOwnProperty.call(item.properties || {}, 'Backorder notice')
      );
      if (!item) {
        document.body.dataset.legacyBackorderCleanup = 'false';
        if (document.body.classList.contains('template-cart')) window.location.replace(cartUrl);
        return;
      }
      const properties = { ...item.properties };
      delete properties['Backorder notice'];
      // An empty object leaves the old property in Shopify's cart, so use a
      // private property when there are no other item details to preserve.
      if (!Object.keys(properties).length) properties._cart_line_migrated = '1';
      const changeResponse = await fetch(changeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: item.quantity, properties })
      });
      if (!changeResponse.ok) throw new Error('Cart could not be updated');
    }
    throw new Error('Cart could not be updated');
  } catch (error) {
    if (status) status.textContent = 'Could not update your cart. Please remove and re-add the affected item to continue.';
  } finally {
    studioCartCleanupPending = false;
  }
}
studioCleanLegacyBackorderCart();

document.addEventListener('click', async event => {
  const link = event.target.closest('[data-cart-remove]');
  if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const cartElement = link.closest('.vc-cart');
  if (!cartElement) return;
  event.preventDefault();
  if (studioCartRemovalPending || studioCartCleanupPending) return;
  studioCartRemovalPending = true;
  const errorElement = cartElement.querySelector('[data-cart-remove-error]');
  const links = [...cartElement.querySelectorAll('[data-cart-remove]')];
  const buttons = [...cartElement.querySelectorAll('button')].map(button => [button, button.disabled]);
  errorElement.hidden = true;
  cartElement.setAttribute('aria-busy', 'true');
  links.forEach(item => item.setAttribute('aria-disabled', 'true'));
  buttons.forEach(([button]) => button.disabled = true);
  try {
    const cartUrl = cartElement.dataset.cartUrl;
    const properties = studioCartProperties(JSON.parse(link.dataset.properties));
    for (let attempt = 0; attempt < 2; attempt++) {
      const cartResponse = await fetch(cartUrl + '.js', { cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('Cart could not be loaded');
      const cart = await cartResponse.json();
      let item = cart.items.find(item => item.key === link.dataset.itemKey);
      if (!item) {
        const matches = cart.items.filter(item =>
          String(item.variant_id) === link.dataset.variantId &&
          studioCartProperties(item.properties) === properties &&
          String(item.selling_plan_allocation?.selling_plan?.id || '') === link.dataset.sellingPlanId
        );
        // If the item disappeared or its identity is ambiguous, refresh safely.
        if (matches.length !== 1) break;
        item = matches[0];
      }
      const response = await fetch(cartElement.dataset.cartChangeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      });
      if (response.ok) break;
      const error = await response.json().catch(() => ({}));
      // Reconcile once if a gift app changed the key during this request.
      if (attempt === 0 && response.status === 400 && /no valid id or line parameter/i.test(error.description || error.message || '')) continue;
      throw new Error('Cart could not be updated');
    }
    window.location.replace(cartUrl);
  } catch (error) {
    errorElement.hidden = false;
    cartElement.removeAttribute('aria-busy');
    links.forEach(item => item.removeAttribute('aria-disabled'));
    buttons.forEach(([button, disabled]) => button.disabled = disabled);
    studioCartRemovalPending = false;
  }
});
